/**
 *
 * @module tokenRefreshFailure
 *
 */

/**
 *
 * @class TokenRefreshFailure
 *
 */
export default class TokenRefreshFailure {

    /**
     *
     * @param {Exception} error
     *
     */
    constructor(error) {

        /**
         *
         * @access public
         * @type {Exception}
         *
         */
        this.error = error;

    }

}



// WEBPACK FOOTER //
// ./src/token/tokenRefreshFailure.js